import React, { useEffect } from "react";
import { getConfiguration } from "../apis";

/**
 *  The context.
 */
export const LocationContext = React.createContext(null);

const initialContext = {
  country: "",
  countryName: "",
  continent: "",
  ip: "",
};

/**
 *  The Context Provider.
 *
 *  @param {} props
 */
export const LocationContextProvider = (props) => {
  const [state, setState] = React.useState(initialContext);

  /** Effect to get the configuration from the back-end. */
  useEffect(() => {
    // Local function to absorb async.
    let get = async () => {
      var c = await Promise.all([getConfiguration()]);
      let configuration = c[0];

      if (configuration) {
        setState({
          country: configuration.sourceCountry,
          continent: configuration.sourceContinent,
          ip: configuration.ip,
        });
      }
    };

    // Get the configuration.
    get();
  }, []);

  // Render.
  return <LocationContext.Provider value={state}>{props.children}</LocationContext.Provider>;
};
